module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("APC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acts of the Privy Council")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Correspondence of Erasmus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("R.A.B. Mynors, A. Dalzell and J.M. Estes, eds., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Correspondence of Erasmus: Letters 1356 to 1534")]), _vm._v(", Toronto, University of Toronto Press, 1974 continuing")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CSPD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Calendar of State Papers, Domestic")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CSPVen")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Calendar of State Papers, Venetian")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_vm._v("Hall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicle")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lives of the Kings. By Edward Hall")]), _vm._v(" ed. C. Whibley, 2 vols. London, T.C. and E.C. Jack, 1904")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_vm._v("L&P")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Letters and Papers, Foreign and Domestic, Henry VIII")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_vm._v("LMA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("London Metropolitan Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ODNB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oxford Dictionary of National Biography")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_vm._v("TNA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The National Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindentl"
  }, [_vm._v("VCH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Victoria History of the Counties of England")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6b4a84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Abbreviations.vue
// module id = 75
// module chunks = 0